import { render } from "./AccordionComponent.vue?vue&type=template&id=15c87afe"
import script from "./AccordionComponent.vue?vue&type=script&lang=js"
export * from "./AccordionComponent.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/sanremo-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__